import React from 'react';
import {
  Dialog, DialogContent,
  Box, Link, Typography,
} from '@mui/material';
import { environment } from '@/config/environment';
import { UNIFIED_DIALOG_PAPER_SX } from '@/components/shared/dialogStyles';

interface Props {
  open: boolean;
}

export const SessionDialog: React.FC<Props> = ({ open }) => {
  const signoutUrl = `${window.location.origin}/.auth/logout?post_logout_redirect_uri=${encodeURIComponent(`${window.location.origin}/.auth/logout/complete`)}`;

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth={false}
      slotProps={{ paper: { sx: UNIFIED_DIALOG_PAPER_SX } }}
    >
      <DialogContent>
        <Box id="qa-notificationHeader-lbl" sx={{ fontWeight: 600, mb: 1 }}>
          Page failed to load
        </Box>
        <Typography id="qa-notificationmessage-lbl" sx={{ mb: 2 }}>
          You are not allowed to access OTD.
        </Typography>
        <Link id="qa-signOut-lnk" href={signoutUrl} underline="hover">
          Sign Out
        </Link>
      </DialogContent>
    </Dialog>
  );
};
